<template>
  <div>
    <loader
      v-if="loader"
      object="#2E7D32"
      color1="#398abe"
      color2="#92c2bf"
      size="10"
      speed="2"
      objectbg="#999793"
      opacity="30"
      disableScrolling="false"
      name="circular"
    ></loader>
  </div>
</template>
<script>
export default {
    props: {
        loader: {
          type: Boolean,
          default: true,
        }
    }
          // bg="#9199a1"

}
</script>